<template>
  <div class="window-nav">
    <div class="window-nav-inner">
      <div class="window-nav-top">
        <button class="window-nav-close" @click="$emit('selectCover')"><i class="icon-chevron-b"></i></button>
        Choose main picture
      </div>

      <div class="form-block--pic-radios">
        <div class="pic-radio-upload-wrapper">
          <div class="pic-radio-upload-before">
            <input id="upload-new-cover" ref="photo" type="file" name="upload-new-cover" accept="image/*" @change="uploadPhoto()">
            <img src="../../../assets/images/pic3.svg">
          </div>
          <div class="pic-radio-upload-after" v-if="uploadedPhoto.idFile">
            <label v-if="uploadedPhoto.idFile" class="pic-radio pic-radio-wrapper pic-radio-uploaded">
              <input type="radio" name="add-new-cover" :value="uploadedPhoto.idFile" @click="$emit('selectPhoto', uploadedPhoto)">
              <span class="pic-radio-img">
                    <span :style="`background-image:url(${imageUrl}/${uploadedPhoto.idFile});`" />
                  </span>
              <span class="pic-radio-label">
                    <i class="icon-check"></i> Main picture
                  </span>
            </label>
          </div>
          <label for="upload-new-cover" class="button-icon">Upload photo  <i class="icon-img"></i></label>
        </div>

        <div class="radios-wrapper">
          <label class="pic-radio pic-radio-wrapper" v-for="cover in allCovers" :key="cover">
            <input type="radio" name="add-new-cover" :value="cover" @click="$emit('selectPhoto', cover)">
            <span class="pic-radio-img">
                  <span :style="`background-image:url(https://engage.edge.capgemini.com/${cover});`" />
                </span>
            <span class="pic-radio-label">
                  <i class="icon-check"></i> Main picture
                </span>
          </label>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import files from "@/api/files";
import settings from "@/settings";

export default {
  name: "MobileCoverPopup",
  data() {
    return {
      uploadedPhoto: {},
      uploadingImage: false,
      imageUrl: `${settings.API_BASE_PATH}/image`
    }
  },
  computed: {
    allCovers() {
      return this.$store.getters.defaultImages;
    },
  },
  methods: {
    uploadPhoto () {
      this.uploadingImage = true
      let file = this.$refs.photo.files[0]
      files.addFile(file, (data) => {
        this.uploadedPhoto = data
        this.uploadingImage = false
      })
    },
  }
}
</script>

<style scoped>

</style>